/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { PaymentOpsPaymentEventDto } from './PaymentOpsPaymentEventDto';
import {
    PaymentOpsPaymentEventDtoFromJSON,
    PaymentOpsPaymentEventDtoFromJSONTyped,
    PaymentOpsPaymentEventDtoToJSON,
    PaymentOpsPaymentEventDtoToJSONTyped,
} from './PaymentOpsPaymentEventDto';

/**
 * 
 * @export
 * @interface UnknownStatePaymentDto
 */
export interface UnknownStatePaymentDto {
    /**
     * 
     * @type {number}
     * @memberof UnknownStatePaymentDto
     */
    paymentId: number;
    /**
     * 
     * @type {string}
     * @memberof UnknownStatePaymentDto
     */
    paymentReference: string;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof UnknownStatePaymentDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {UnknownStatePaymentDtoPaymentMethodEnum}
     * @memberof UnknownStatePaymentDto
     */
    paymentMethod: UnknownStatePaymentDtoPaymentMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof UnknownStatePaymentDto
     */
    executingLocationId: number;
    /**
     * 
     * @type {Array<PaymentOpsPaymentEventDto>}
     * @memberof UnknownStatePaymentDto
     */
    events: Array<PaymentOpsPaymentEventDto>;
    /**
     * 
     * @type {Date}
     * @memberof UnknownStatePaymentDto
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof UnknownStatePaymentDto
     */
    updated: Date;
    /**
     * 
     * @type {boolean}
     * @memberof UnknownStatePaymentDto
     */
    canExcludeFromWashing: boolean;
}


/**
 * @export
 */
export const UnknownStatePaymentDtoPaymentMethodEnum = {
    CARD: 'CARD',
    VIPPS: 'VIPPS',
    APPLE_PAY: 'APPLE_PAY',
    MOBILE_PAY: 'MOBILE_PAY',
    GOOGLE_PAY: 'GOOGLE_PAY',
    SWISH: 'SWISH',
    INTEGRATED_TERMINAL: 'INTEGRATED_TERMINAL',
    MOBILE_CARD_TERMINAL: 'MOBILE_CARD_TERMINAL',
    INVOICE: 'INVOICE',
    CASH: 'CASH',
    FREE: 'FREE',
    BILL_ON_ROOM: 'BILL_ON_ROOM'
} as const;
export type UnknownStatePaymentDtoPaymentMethodEnum = typeof UnknownStatePaymentDtoPaymentMethodEnum[keyof typeof UnknownStatePaymentDtoPaymentMethodEnum];


/**
 * Check if a given object implements the UnknownStatePaymentDto interface.
 */
export function instanceOfUnknownStatePaymentDto(value: object): value is UnknownStatePaymentDto {
    if (!('paymentId' in value) || value['paymentId'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('executingLocationId' in value) || value['executingLocationId'] === undefined) return false;
    if (!('events' in value) || value['events'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    if (!('canExcludeFromWashing' in value) || value['canExcludeFromWashing'] === undefined) return false;
    return true;
}

export function UnknownStatePaymentDtoFromJSON(json: any): UnknownStatePaymentDto {
    return UnknownStatePaymentDtoFromJSONTyped(json, false);
}

export function UnknownStatePaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnknownStatePaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentId': json['paymentId'],
        'paymentReference': json['paymentReference'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentMethod': json['paymentMethod'],
        'executingLocationId': json['executingLocationId'],
        'events': ((json['events'] as Array<any>).map(PaymentOpsPaymentEventDtoFromJSON)),
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'canExcludeFromWashing': json['canExcludeFromWashing'],
    };
}

export function UnknownStatePaymentDtoToJSON(json: any): UnknownStatePaymentDto {
    return UnknownStatePaymentDtoToJSONTyped(json, false);
}

export function UnknownStatePaymentDtoToJSONTyped(value?: UnknownStatePaymentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentId': value['paymentId'],
        'paymentReference': value['paymentReference'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentMethod': value['paymentMethod'],
        'executingLocationId': value['executingLocationId'],
        'events': ((value['events'] as Array<any>).map(PaymentOpsPaymentEventDtoToJSON)),
        'created': value['created'].toISOString(),
        'updated': value['updated'].toISOString(),
        'canExcludeFromWashing': value['canExcludeFromWashing'],
    };
}

